<template>
    <transition name="fade">
        <span
            class="z-10 cursor-pointer"
            :class="spanPositioningClasses"
            @click="handlePagination"
        >
            <svg-icon
                icon="arrow-horizontal"
                class="transition-all duration-200 text-gold-500 w-8 h-4"
                :class="iconClasses"
            />
        </span>
    </transition>
</template>

<script>
import SvgIcon from '@whisper/components/icons/SvgIcon';

export default {
  name: 'ProductGalleryPaginator',
  components: {
    SvgIcon,
  },
  props: {
    handlePagination: {
      type: Function,
      required: true,
    },
    direction: {
      type: String,
      required: true,
      validator(value) {
        return ['next', 'previous'].indexOf(value) !== -1;
      },
    },
  },
  computed: {
    spanPositioningClasses() {
      if (this.direction === 'previous') {
        return 'left-0 mr-3';
      }

      if (this.direction === 'next') {
        return 'right-0 ml-3';
      }
    },
    iconClasses() {
      if (this.direction === 'previous') {
        return [
          'arrow-left',
          'rotate-180',
          'transform',
          'hover:rotate-180',
        ];
      }

      if (this.direction === 'next') {
        return [
          'arrow-right',
        ];
      }
    },
  },
};
</script>

<style scoped>

</style>
